module.exports = __webpack_public_path__ + "static/desktop/img/typeset-mobile-diarybook.6084102d.png";